/* eslint-disable function-paren-newline */
// eslint-disable-next-line no-use-before-define
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import Button from "../../shared/components/button/button";
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import * as tenatActions from "../../store/tenant/action";
import * as actions from "../../store/product/action";
import { getTenantDetail } from "../../store/tenant/api";
import {
  mapStateToPropsProductList,
  Props,
  State,
} from "../../shared/interfaces/components/productList.interface";
import { Product } from "../../shared/interfaces/model/product.interface";
import { DEFAULT_USER_ROLE, getJWTDecoded } from "../../../utils/userUtils";
import { mapStateToPropsDetailsTenant } from "../../shared/interfaces/components/detailsTenant.interface";
import { Tenant } from "../../shared/interfaces/model/tenant.interface";
import ProductActions from "./productActions";
import MainLayout from "../../shared/components/MainLayout";
import Loader from "../../shared/components/loader/Loader";
import Button2 from "../../shared/components/button/Button2";
import { PlusIcon } from "lucide-react";

class ProductList extends Component<Props, State> {
  componentDidMount() {
    this.props.getProductListRequest();
    const tenantId = localStorage.getItem("tenantId");
    if (tenantId) {
      this.props.getTenantDetail(tenantId);
    }
  }

  userRole = parseInt(
    window.localStorage.getItem("role") || DEFAULT_USER_ROLE,
    10
  );

  token = window.localStorage.getItem("token");

  renderProductList = () => {
    const { productList, tenantDetails } = this.props;
    const userInfo = getJWTDecoded(this.token || "");
    const productMap = new Map<string, string>();

    if (userInfo.products) {
      userInfo.products.forEach((prod, i) => {
        productMap.set(prod, prod);
      });
    }

    return (
      <div className="table-content">
        <ProductActions
          productList={productList ?? []}
          paidProductDetails={tenantDetails?.testProducts ?? []}
          userInfo={userInfo}
          userRole={this.userRole}
          productMap={productMap}
        />
      </div>
    );
  };

  render() {
    return (
      <MainLayout>
        <Loader isLoading={!Boolean(this.props.productListIsOk)} />
        <div
          className=""
          data-test="productList"
        >
          <section className="p-2 md:p-10 w-full box-border flex flex-row flex-wrap justify-center text-center">
            <article className="between-xs row col-xs-12 productList--title middle-xs">
              <p className="text-2xl font-bold">Lista prodotti</p>
              <table>
                <thead>
                  <tr>
                    <th>
                      <Link to="/private/createproduct">
                        {this.userRole === 0 && (
                          <Button2
                            title="Crea Prodotto"
                            icon={PlusIcon}
                            theme="primary"
                            iconPosition="left"
                            
                            onClick={() => null}
                          />
                        )}
                      </Link>
                    </th>
                  </tr>
                </thead>
              </table>
            </article>
            <div
              className="table shadow-md bg-gray-50 mt-5"
              data-test="tenantListTable"
            >
              <div className="table-header">
                <div
                  className={`table-data col-xs-${this.userRole === 0 ? "4" : "6"
                    }`}
                >
                  <a className="filter__link">Nome</a>
                </div>
                {this.userRole === 0 && (
                  <div className="header__item col-xs-4">
                    <a className="filter__link">Codice App</a>
                  </div>
                )}
                <div
                  className={`table-data col-xs-${this.userRole === 0 ? "4" : "6"
                    }`}
                >
                  <a className="filter__link">Prezzo</a>
                </div>
                <div
                  className={`table-data col-xs-${this.userRole === 0 ? "4" : "6"
                    }`}
                >
                  <a className="filter__link">Azioni</a>
                </div>
              </div>
              {this.renderProductList()}
            </div>
          </section>
        </div>
      </MainLayout>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getProductListRequest: (payload?: string) => {
    dispatch(actions.getProductListRequest(payload));
  },
  getTenantDetail: (payload: string) => {
    dispatch(tenatActions.getDetailsTenantRequest(payload));
  }
});

type storeState = mapStateToPropsProductList & mapStateToPropsDetailsTenant;

const mapStateToProps = (state: any) => ({
  // Recupero della lista dei prodotti e dello stato della richiesta
  productList: state.productReducer?.productList?.products,
  productListIsOk: state.productReducer?.productListIsOk,
  tenantDetails: state?.tenantsReducer?.detailsTenant,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
